import React from 'react'
import { Step, Stepper, StepLabel } from 'material-ui/Stepper'
import RaisedButton from 'material-ui/RaisedButton'
import ExpandTransition from 'material-ui/internal/ExpandTransition'
import { connect } from 'react-redux'
import { reduxForm, change } from 'redux-form'
import SweetAlert from 'sweetalert-react'
import MissionPage from '../MissionPage'
import { newTryStarted, missionAlertShowed,
  pageAnswered, missionAnswered,
  partialMissionAnswered } from '../../../actions'

class ShowMissionStepper extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      finished: false,
      answering: false,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.current_step < this.props.current_step) {
      this.setState({ loading: true }, () =>
        setTimeout(() => this.setState({ loading: false }), 500),
      )
    }
    if (!prevProps.alert.show && this.props.alert.show && this.props.alert.time) {
      setTimeout(() => this.props.missionAlertShowed(), this.props.alert.time)
    }
    if (this.props.finished && !this.state.finished) {
      this.setState({ finished: true }, () =>
        this.props.missionAnswered(this.props.formAnswers.values))
    }
    if (!prevProps.alert.show && this.props.alert.show && this.props.alert.time) {
      setTimeout(() => {
        this.props.missionAlertShowed()
        this.setState({ loading: false })
      }, this.props.alert.time)
    }
  }

  inLastStep = () =>
    this.props.current_step === (this.props.pages_to_answer.length - 1)

  pageAnswered = () => {
    if (this.inLastStep()) {
      this.setState({ loading: true })
    }

    // console.log('PROPS: ', this.props)
    // console.log('FORM ANSWERS VALUES: ', this.props.formAnswers.values)
    // console.log('PAGE TYPE: ', this.props.mission_pages[this.props.current_step].page_type)

    this.props.partialMissionAnswered({
      answers: this.props.formAnswers.values,
      attempt: this.props.current_attempt,
      step: this.props.current_step,
    })
    this.props.pageAnswered({
      answer: this.props.formAnswers.values,
    })
  }

  steps = () => this.props.pages_to_answer.map(page =>
    <Step key={page.id} >
      <StepLabel />
    </Step>,
  )

  current_page = () => {
    const has_pages = this.props.pages_to_answer.length > 0
    const page_to_answer = has_pages ? this.props.pages_to_answer[this.props.current_step] : null
    return page_to_answer && (<MissionPage
      key={page_to_answer.id} mission_page={{ ...page_to_answer }}
    />)
  }

  _nextButtonLabel = () =>
    (this.inLastStep() ? 'Finalizar y Enviar Respuestas' : 'Siguiente')

  render = () => (

    <div style={{ width: '100%', margin: 'auto' }}>
      <SweetAlert
        show={this.props.alert.show}
        title={this.props.alert.title}
        text={this.props.alert.text}
        type={this.props.alert.type}
        showConfirmButton={this.props.alert.showConfirmButton}
        onConfirm={() => {
          this.props.missionAlertShowed()
          this.setState({ loading: false })
        }}
        confirmButtonColor={this.props.alert.confirmButtonColor}
        imageUrl={this.props.alert.imageUrl}
        imageSize="250x250"
      />
      <Stepper activeStep={this.props.current_step}>
        { this.steps() }
      </Stepper>
      <ExpandTransition loading={this.state.loading} open>
        <div>
          {this.current_page()}
        </div>
        <div style={{ marginTop: 24, marginBottom: 12, float: 'right' }}>
          <RaisedButton
            label={this._nextButtonLabel()}
            primary
            onTouchTap={this.pageAnswered}
          />
        </div>
      </ExpandTransition>
    </div>
  )
}

ShowMissionStepper.propTypes = {
  finished: React.PropTypes.bool,
  pages_to_answer: React.PropTypes.arrayOf(
    React.PropTypes.shape({
      id: React.PropTypes.number,
    }),
  ),
  missionAlertShowed: React.PropTypes.func,
  pageAnswered: React.PropTypes.func,
  missionAnswered: React.PropTypes.func,
  partialMissionAnswered: React.PropTypes.func,
  formAnswers: React.PropTypes.shape({
    values: React.PropTypes.shape(),
    registeredFields: React.PropTypes.shape(),
  }),
  alert: React.PropTypes.shape({
    show: React.PropTypes.bool,
    title: React.PropTypes.string,
    text: React.PropTypes.string,
    type: React.PropTypes.string,
    confirmButtonColor: React.PropTypes.string,
    showConfirmButton: React.PropTypes.bool,
    imageUrl: React.PropTypes.string,
    time: React.PropTypes.Number,
    html: React.PropTypes.shape(),
  }),
  current_step: React.PropTypes.number,
  current_attempt: React.PropTypes.number,
}


const mapStateToProps = state => ({
  ...state.missions.selectedMission,
  formAnswers: { ...state.form.MissionAnswerForm },
  goToNextPage: state.missions.answerMission.progress.goToNextPage,
  errors: [...state.missions.answerMission.progress.errors],
  pages_to_answer: [...state.missions.answerMission.progress.pages_to_answer],
  current_step: state.missions.answerMission.progress.step,
  current_attempt: state.missions.answerMission.progress.attempt,
  alert: state.missions.answerMission.progress.alert,
  finished: state.missions.answerMission.progress.finished,
})

const mapDispatchToProps = dispatch => ({
  pageAnswered: payload => dispatch(pageAnswered(payload)),
  missionAnswered: answers => dispatch(missionAnswered(answers)),
  missionAlertShowed: () => dispatch(missionAlertShowed()),
  newTryStarted: () => dispatch(newTryStarted()),
  cleanField: field => dispatch(change('MissionAnswerForm', field, '')),
  partialMissionAnswered: answers => dispatch(partialMissionAnswered(answers)),
})

const ReduxMissionAnswerForm = reduxForm({
  form: 'MissionAnswerForm',
})(ShowMissionStepper)


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReduxMissionAnswerForm)




// WEBPACK FOOTER //
// ./src/components/MissionShow/ShowMissionStepper/index.jsx